<template>
  <el-form
    label-position="top"
    ref="form"
    :model="form"
    :rules="rules"
    :validate-on-rule-change="false"
  >
    <el-row>
      <el-col
        :xl="8"
        :lg="12"
        :md="24"
        :sm="24"
        :xs="24"
        v-for="(item, index) in formModel"
        :key="index"
      >
        <el-form-item :label="item.label" :prop="item.key">
          <el-input
            v-if="item.type === 'input'"
            v-model="form[item.key]"
            :placeholder="item.placeholder"
            style="width: 300px"
          />
          <el-select
            v-else-if="item.type === 'select'"
            v-model="form[item.key]"
            :placeholder="item.placeholder"
            style="width: 300px"
            filterable
          >
            <el-option
              v-for="selectOption in item.selectList"
              :value="selectOption.id"
              :key="selectOption.id"
              :label="selectOption.name"
            ></el-option>
          </el-select>
          <el-date-picker
            valueFormat="yyyy-MM-dd"
            v-else-if="item.type === 'date'"
            v-model="form[item.key]"
            style="width: 300px"
          />
          <el-checkbox
            v-else-if="item.type === 'checkbox'"
            v-model="form[item.key]"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      rules: {},
    }
  },
  props: {
    formModel: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    formModel: {
      deep: true,
      immediate: true,
      handler(newValue) {
        newValue.forEach(item => {
          this.$set(
            this.form,
            item.key,
            this.$utils.isFalse(item.defaultValue) ? '' : item.defaultValue,
          )
          if (item.rule) this.rules[item.key] = item.rule
        })
      },
    },
  },
  methods: {
    getFormData() {
      return { ...this.form }
    },
    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve({ ...this.form })
          }
          resolve(null)
        })
      })
    },
  },
}
</script>
